import moment from 'moment/moment';

export function displayFormattingTime(time) {
  return moment(time).format('YYYY-MM-DD');
}

// months array
export function monthArray(start, term) {
  const x = [];
  for (let i = 0; i < term; i++) {
    x.push(
      moment(start, 'YYYY-MM')
        .subtract(i, 'months')
        .format('YYYY-MM')
    );
  }
  return x;
}
